import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveConsultationType() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((consultationTypeId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = consultationTypeId
      ? quarkusApi.put(`/appointment-types/${consultationTypeId}`, payload, authHeader)
      : quarkusApi.post('/appointment-types', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
